(function(angular) {
  'use strict';

  var directiveName = 'apFindPrmUser';

  angular.module('aprima-core-ui').directive(directiveName, [
    'ApReadonlyFindControl',
    'PrmUserRepository',
    ApFindPrmUser,
  ]);

  function ApFindPrmUser(
    ApReadonlyFindControl, 
    PrmUserRepository
  ) {
      var validationKey = 'prmUserMatch';
      var idProperty = 'Id';
      var templateUrl = '/core-ui/views/directives/find/apFindPrmUser.html';

      var directiveDefinition = ApReadonlyFindControl.init(
        directiveName,
        PrmUserRepository.getUser,
        PrmUserRepository.searchUsers,
        validationKey,
        templateUrl,
        idProperty,
        validator,
        true,
        onInitCtrl
      );

      return directiveDefinition;

      function onInitCtrl(ctrl) {
        ctrl.placeholderText = 'Search users';
        ctrl.getSearchTextFromFindPrmUser = getSearchTextFromFindPrmUser;
      }

      function validator(prmUser) {
        var isValid =  !prmUser ||
                      (prmUser[idProperty] &&
                      (prmUser.hasOwnProperty('FormattedInternalName') || (prmUser.hasOwnProperty('LastName') && prmUser.hasOwnProperty('FirstName'))));
        return isValid;
      }

      function getSearchTextFromFindPrmUser(prmUser) {
        if (prmUser && prmUser.FormattedInternalName) {
          return prmUser.FormattedInternalName;
        } else if (prmUser && prmUser.LastName && prmUser.FirstName) {
          return prmUser.LastName + ', ' + prmUser.FirstName;
        }
        return '';
      }
    }

})(window.angular);
